module.exports = __webpack_public_path__ + "static/img/celoscope-25.0ea47a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-25.jpg
// module id = PYTe
// module chunks = 51